var indexOf = [].indexOf;

import featureNames from 'constants/feature_names';

angular.module('gym.components').directive('membershipFirstStep', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/membership/membership_first_step.html.slim'),
    scope: {
      contact: '=',
      isClassesLimitValid: '&',
      isClassesIntervalValid: '&',
      membership: '=',
      newMembershipPlan: '=',
      membershipPlans: '=',
      membershipPlanCategories: '=',
      eventTypes: '=',
      gradingStyles: '=',
      targetMembershipId: '='
    },
    controller: ["$scope", "$rootScope", "$modal", "$http", "MembershipIntervalUnits", "MembershipPlanService", "MembershipPlans", "EventTypes", "EventService", "loadingAnimation", function($scope, $rootScope, $modal, $http, MembershipIntervalUnits, MembershipPlanService, MembershipPlans, EventTypes, EventService, loadingAnimation) {
      var base, getMembershipPlanParams, reloadEventTypes;
      $scope.membershipPlan = $scope.newMembershipPlan;
      $scope.membership_interval_unit_pairs = _.pairs(MembershipIntervalUnits);
      $scope.gym = $rootScope.gym;
      $scope.isMartialArts = $rootScope.gym.is_martial_arts;
      (base = $scope.membership).future_booking_term_unit || (base.future_booking_term_unit = 'weeks');
      $scope.featureNames = featureNames;
      $scope.membershipPlanOptions = $scope.membershipPlans.map(function(membershipPlan) {
        var label, name, purchase_limit, purchases_remaining;
        name = membershipPlan.label;
        purchase_limit = membershipPlan.purchase_limit;
        purchases_remaining = membershipPlan.purchases_remaining;
        label = purchase_limit > 0 && purchases_remaining === 0 ? `${name} (Sold out)` : purchase_limit > 0 && purchases_remaining !== 0 ? `${name} (${purchases_remaining} remaining)` : name;
        return {
          label: label,
          value: membershipPlan
        };
      });
      $scope.isTypeSelected = function(id) {
        return indexOf.call($scope.membership.event_type_ids, id) >= 0;
      };
      $scope.isStyleSelected = function(id) {
        return indexOf.call($scope.membership.style_ids, id) >= 0;
      };
      $scope.toggleType = function(id) {
        if ($scope.isTypeSelected(id)) {
          return $scope.membership.event_type_ids = _.without($scope.membership.event_type_ids, id);
        } else {
          return $scope.membership.event_type_ids.push(id);
        }
      };
      $scope.toggleStyle = function(id) {
        if ($scope.isStyleSelected(id)) {
          return $scope.membership.style_ids = _.without($scope.membership.style_ids, id);
        } else {
          return $scope.membership.style_ids.push(id);
        }
      };
      reloadEventTypes = function() {
        return $scope.eventTypes = EventTypes.getList({
          count: 1000
        }).$object;
      };
      $scope.manageTypes = function() {
        var roomModal;
        roomModal = $modal.open({
          template: require('templates/gyms/calendar/events/manage_types.html.slim'),
          controller: 'ManageEventTypesModal',
          resolve: {
            types: function() {
              return $scope.eventTypes;
            }
          }
        });
        return roomModal.result.then(function() {
          return reloadEventTypes();
        }, function() {
          return reloadEventTypes();
        });
      };
      $scope.loadDefaultDates = function(useSelectedDate) {
        var params, ref, ref1, uuid;
        uuid = (ref = $scope.membership) != null ? (ref1 = ref.membership_plan) != null ? ref1.uuid : void 0 : void 0;
        if (!uuid) {
          return;
        }
        params = {
          gid: $rootScope.gym.id
        };
        if (useSelectedDate) {
          params.purchase_date = $scope.membership.start_date;
        }
        return $http.get(`/membership_defaults/${uuid}`, {
          params: params
        }).then(function(response) {
          $scope.membership.start_date = response.data.start_date;
          $scope.membership.upfront_payment_on = response.data.upfront_payment_on;
          return $scope.membership.recurring_payments_start_on = response.data.recurring_payments_start_on;
        });
      };
      $scope.onMembershipPlanSelected = function() {
        if ($scope.membership.membership_plan.id) {
          loadingAnimation.show();
          return MembershipPlans.get($scope.membership.membership_plan.id).then(function(plan) {
            var startDate;
            angular.extend($scope.membership.membership_plan, plan.plain());
            angular.extend($scope.membership, getMembershipPlanParams(), {
              create_plan_from_membership: void 0
            });
            startDate = MembershipPlanService.getStartDate(plan);
            if (startDate) {
              $scope.membership.start_date = startDate;
            }
            $scope.loadDefaultDates();
            return loadingAnimation.hide();
          }, function() {
            return loadingAnimation.hide();
          });
        } else {
          return angular.extend($scope.membership, MembershipPlanService.build($scope.newMembershipPlan), {
            create_plan_from_membership: true
          });
        }
      };
      if ($scope.targetMembershipId && !$scope.membership.membership_plan) {
        $scope.membership.membership_plan = _.find($scope.membershipPlans, function(plan) {
          return plan.id === $scope.targetMembershipId;
        });
        $scope.onMembershipPlanSelected();
      }
      getMembershipPlanParams = function() {
        var membership;
        membership = _.omit($scope.membership.membership_plan, ['id', 'links', 'errors', 'uuid', 'position']);
        if (membership.category) {
          membership.category_id = membership.category.id;
        }
        membership.not_classes_interval = membership.classes_unlimited || !membership.classes_interval_number;
        return membership;
      };
      $scope.recurringBookingsDisabled = function() {
        return !$scope.membership.classes_unlimited && (!$scope.membership.classes_interval_number || $scope.membership.not_classes_interval);
      };
      $scope.onClassesIntervalChanged = function() {
        $scope.membership.classes_interval_number = 0;
        return $scope.membership.allow_recurring_bookings = false;
      };
      $scope.onClassesLimitChange = function() {
        if ($scope.membership.classes_limit > 0) {
          return $scope.membership.classes_unlimited = false;
        }
      };
      $scope.onClassesIntervalNumberChange = function() {
        if ($scope.membership.classes_interval_number > 0) {
          return $scope.membership.not_classes_interval = false;
        }
      };
      $scope.onClassesLimitTypeChanged = function() {
        var base1;
        $scope.membership.classes_limit = 0;
        if ($scope.membership.classes_unlimited) {
          $scope.membership.classes_interval_number = 0;
          $scope.membership.not_classes_interval = true;
          return (base1 = $scope.membership).future_booking_term_unit || (base1.future_booking_term_unit = 'weeks');
        } else {
          $scope.membership.restrict_future_bookings_by_count = false;
          $scope.membership.restrict_future_bookings_by_date = false;
          $scope.membership.future_bookings_count_limit = null;
          $scope.membership.future_booking_term_number = null;
          $scope.membership.future_booking_term_unit = null;
          return $scope.membership.allow_recurring_bookings = false;
        }
      };
      $scope.openMembershipPlanCategoryManagement = function() {
        return $modal.open({
          template: require('templates/gyms/membership_plans/membershipPlanCategoryManagement.html.slim'),
          controller: 'MembershipPlanCategoryManagementCtrl',
          resolve: {
            onCategoryChange: function() {
              return function() {
                return $scope.membershipPlanCategories.reload();
              };
            }
          }
        });
      };
      $scope.displayFutureBookingLimitsDescription = function(event, type) {
        event.preventDefault();
        return $modal.open({
          template: require('templates/components/membership_plan/future_booking_limits.html.slim'),
          controller: 'FutureBookingLimitsModal',
          resolve: {
            type: function() {
              return type;
            }
          }
        });
      };
      $scope.displayRecurringBookingsDescription = function(event) {
        event.preventDefault();
        return EventService.displayRecurringBookingsDescription();
      };
      return $scope.displayTrialMembershipDescription = function(event) {
        event.preventDefault();
        return MembershipPlanService.displayTrialMembershipDescription($scope.featureNames);
      };
    }]
  };
});
